var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 4.66853C6.98016 4.25113 7.26998 3.89917 7.65144 3.67498C8.03291 3.45079 8.48141 3.36884 8.91751 3.44364C9.35361 3.51844 9.74917 3.74517 10.0341 4.08367C10.3191 4.42217 10.475 4.8506 10.4744 5.29306C10.4744 6.54213 8.60077 7.16667 8.60077 7.16667M8.62492 9.66667H8.63325M4.33333 13V14.9463C4.33333 15.3903 4.33333 15.6123 4.42436 15.7263C4.50352 15.8255 4.62356 15.8832 4.75045 15.8831C4.89636 15.8829 5.06973 15.7442 5.41646 15.4668L7.40434 13.8765C7.81043 13.5517 8.01347 13.3892 8.23957 13.2737C8.44017 13.1712 8.65369 13.0963 8.87435 13.051C9.12306 13 9.38308 13 9.90312 13H12C13.4001 13 14.1002 13 14.635 12.7275C15.1054 12.4878 15.4878 12.1054 15.7275 11.635C16 11.1002 16 10.4001 16 9V4.5C16 3.09987 16 2.3998 15.7275 1.86502C15.4878 1.39462 15.1054 1.01217 14.635 0.772484C14.1002 0.5 13.4001 0.5 12 0.5H5C3.59987 0.5 2.8998 0.5 2.36502 0.772484C1.89462 1.01217 1.51217 1.39462 1.27248 1.86502C1 2.3998 1 3.09987 1 4.5V9.66667C1 10.4416 1 10.8291 1.08519 11.147C1.31635 12.0098 1.99022 12.6836 2.85295 12.9148C3.17087 13 3.55836 13 4.33333 13Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlay);
export default __webpack_public_path__ + "static/media/how-to-play.2915f59f4a6a5353296c54945a41dad7.svg";
export { ForwardRef as ReactComponent };